import { render, staticRenderFns } from "./com-search.vue?vue&type=template&id=c5437776&scoped=true&"
import script from "./com-search.vue?vue&type=script&lang=js&"
export * from "./com-search.vue?vue&type=script&lang=js&"
import style0 from "./com-search.vue?vue&type=style&index=0&id=c5437776&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5437776",
  null
  
)

export default component.exports